function sample(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

function range(length, start = 0) {
  return [ ...Array(length).keys() ].map(i => i + start);
}

function shuffle(arr) {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

module.exports = {
  sample,
  range,
  shuffle
};
